<template>
  <el-checkbox-group v-model="statuses">
    <el-checkbox
      v-for="(item, index) in feedStatusItems"
      :label="item.name"
      :key="index"
    >
      {{item.title}}
    </el-checkbox>
  </el-checkbox-group>
</template>

<script>
  // vuex
  import { mapGetters } from "vuex";

  // store
  import {SET_FEED_STATUS, SET_PAGE} from '@/store/actions/feeds';

  export default {
    name: "FeedStatus",
    computed: {
      ...mapGetters([
        "feedStatus",
        "feedStatusItems",
      ]),
      statuses: {
        get() {
          return this.feedStatus;
        },
        set(statuses) {
          if (statuses.length === 0) {
            return false;
          }

          this.$store.dispatch(SET_FEED_STATUS, statuses);
          this.$store.dispatch(SET_PAGE, 1);

          this.$emit("currentPageStatus", 1);

          this.$emit("currentChangeStatus", this.feedStatus);
        }
      }
    }
  };
</script>
